// src/hooks/useDocumentTitle.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from '@/routes';

export function useDocumentTitle(defaultTitle = 'SourceLink ®') {
  const location = useLocation();

  useEffect(() => {
    const currentRoute = routes.find(
      (route) => route.path === location.pathname,
    );
    const title = currentRoute
      ? `${currentRoute.title} | ${defaultTitle}`
      : defaultTitle;
    document.title = title;

    // Cleanup - restore the default title when component unmounts
    return () => {
      document.title = defaultTitle;
    };
  }, [location, defaultTitle]);
}
